var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c(`${_vm.service}-view`,{tag:"component",attrs:{"service-type":_vm.service,"service-type-id":_vm.serviceTypeId,"action":"edit"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }